const categoryConfig = {
  save_admin: {
    entityKey: 'organization',
    dependencyKey: 'organization_id',
    linkTo: 'organization',
  },
  org_user: {
    entityKey: 'organization',
    dependencyKey: 'organization_id',
    linkTo: 'organization',
  },
  agent_user: {
    entityKey: 'project',
    dependencyKey: 'project_id',
    linkTo: 'project',
  },
  group_member: {
    entityKey: 'group',
    dependencyKey: 'group_id',
    linkTo: 'group',
  },
};

const abbreviations = ['sa', 'ssa'];

const formatName = name =>
  name
    ?.split('_')
    ?.map(word =>
      abbreviations.includes(word)
        ? word.toUpperCase()
        : word.charAt(0).toUpperCase() + word.slice(1),
    )
    ?.join(' ');

const formatAssignment = (assignment, config) => {
  const entity = assignment[config.entityKey];
  return {
    name:
      entity?.name ||
      assignment.group_name ||
      assignment.organization_name,
    id: entity?.id || assignment[config.dependencyKey],
    organization_id:
      entity?.organization_id || assignment.organization_id,
    status: assignment.status ?? true,
  };
};

export default ({ data, params }) => {
  const { user, roles } = data;

  const categories = {};
  roles?.forEach(role => {
    if (!role.category) return;
    if (!categories[role.category]) categories[role.category] = [];
    categories[role.category].push(role);
  });

  return Object.entries(categories).map(
    ([category, categoryRoles]) => {
      const config =
        categoryConfig[category] || categoryConfig.save_admin;

      const subItems = categoryRoles.map(role => {
        const formattedAssignments = role.assignments?.map(
          assignment => formatAssignment(assignment, config),
        );

        return {
          user: user?.first_name,
          userId: params?.userId,
          title: formatName(role.name),
          status:
            formattedAssignments?.length > 0 &&
            formattedAssignments.some(item =>
              [true, 'active', 'accepted'].includes(item.status),
            ),
          context: role.name,
          subItems: formattedAssignments || [],
        };
      });

      return {
        user: user?.first_name,
        userId: params?.userId,
        title: formatName(category),
        category,
        linkTo: config.linkTo,
        status: subItems.some(item => item.status),
        subItems,
      };
    },
  );
};
